var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPropiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 109,
    viewBox: "0 0 113 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.023 37.0569L61.7775 1.81797C58.5296 -0.60599 53.9979 -0.60599 50.75 1.81797L3.50455 37.0569C1.29195 38.7034 -0.00366211 41.2531 -0.00366211 43.9572V99.5768C-0.00366211 104.39 4.03699 108.295 9.0183 108.295H56.2638V62.64C56.2638 57.8264 60.3044 53.9217 65.2857 53.9217H112.531V43.9572C112.531 41.2531 111.236 38.7034 109.023 37.0569Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.505 108.298C108.486 108.298 112.526 104.393 112.526 99.5798V53.9247L56.259 108.298H103.505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPropiWhite);
export default __webpack_public_path__ + "static/media/logo_propi_white.aee38c665b7ce2691ad379aaee4a09d9.svg";
export { ForwardRef as ReactComponent };